import {IHttpService} from "angular";
import {TmcDefinitions} from "../models/TmcDefinition";
import {AccountId} from "../../account/types/AccountRecord";

export class TmcService {

    public static readonly id = "tmcService";

    /** @ngInject */
    public constructor(private $http: IHttpService) {
    }

    public async current(accountId: AccountId): Promise<TmcDefinitions> {
        const url = `/tradefloor/api/orders/portfolio/${accountId}/tmc`;
        const response = await this.$http.get<TmcDefinitions>(url);
        return response.data;
    }
}
